import { render } from "./image-swiper.vue?vue&type=template&id=8fdb1b70&scoped=true"
import script from "./image-swiper.vue?vue&type=script&lang=js"
export * from "./image-swiper.vue?vue&type=script&lang=js"

import "./image-swiper.vue?vue&type=style&index=0&id=8fdb1b70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fdb1b70"]])

export default __exports__